import { render, staticRenderFns } from "./VanFieldSelectPicker.vue?vue&type=template&id=08fc03ee&scoped=true&"
import script from "./VanFieldSelectPicker.vue?vue&type=script&lang=js&"
export * from "./VanFieldSelectPicker.vue?vue&type=script&lang=js&"
import style0 from "./VanFieldSelectPicker.vue?vue&type=style&index=0&id=08fc03ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fc03ee",
  null
  
)

export default component.exports